<template>
  <div class="flex-valign gate-page" v-loading="dataLoading" element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading" :class="{ closeList: !showGatePanels }">
    <div class="blur-bg map-blur-panel"></div>
    <div class="flex-between gate-title">
      <div>闸机通行记录</div>
      <div class="point-icon iconfont-lunan icon-lunan-gengduoda" @click="searchFormShow = !searchFormShow"></div>
      <div class="gate-type" :class="{ searchFormShow }">
        <el-select placeholder="全部记录" v-model="checkTypeInfo.type" @change="handleGateChange">
          <el-option v-for="item in gateTypes" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </div>
    </div>
    <el-scrollbar ref="gateList" class="ioc-alarm__scrollbar">
      <ul class="ioc-alarm__list__item gateContent">
        <li class="map-blur-panel__list-item gate-item" v-for="(item, index) in gateRecordList" :key="index">
          <div class="item-img" v-if="checkTypeInfo.type == 1">
            <!-- <img
              class="img"
              @click="showViewer"
              onerror="this.src='/images/theme/newDark/default.png'"
              :src="
                getImageUrl(
                  checkTypeInfo.type == 1 ? item.personnelFileCode : item.trafficFileCode
                )
              "
            /> -->
            <img class="img" @click="showViewer" onerror="this.src='/images/theme/newDark/default.png'"
              :src="getImageUrl(item.trafficFileCode)" />
          </div>
          <div v-else class="item-img">
            <img v-if="item.carStatus === '0'" class="img" @click="showCarViewer(imgChange(item.enterImg), $event)"
              onerror="this.src='/images/theme/newDark/default.png'" :src="imgChange(item.enterImg)" />
            <img v-else class="img" @click="showCarViewer(imgChange(item.exitImg), $event)"
              onerror="this.src='/images/theme/newDark/default.png'" :src="imgChange(item.exitImg)" />
          </div>
          <div class="item-info">
            <div class="label flex-between">
              <span style="font-size: 16px">{{
                checkTypeInfo.type == 1 ? item.name : item.enterCarNum
              }}</span>
              <span>{{ handleFilterType(item) }}</span>
            </div>
            <div class="label">{{ item.trafficTime || (item.carStatus === '0' ? item.enterTime : item.exitTime) }}</div>
            <div class="label">{{ item.deviceName || item.parkingLot }}</div>
          </div>
        </li>
        <div class="noData" v-if="gateRecordList.length === 0 && showGatePanels">
          <div class="text-center" style="margin-bottom: 10px">
            <img src="@/common/assets/images/empty.svg" class="no-data_img" />
          </div>
          暂无数据
        </div>
      </ul>
    </el-scrollbar>
    <div v-if="!sceneCode" :class="[
      'map-blur-panel__expand-button right iconfont-lunan',
      showGatePanels
        ? 'icon-lunan-shousuocaidan-copy'
        : 'icon-lunan-shousuocaidan  switch',
    ]" @click="handleClosePanel"></div>
  </div>
</template>

<script>
import { Bus } from "$utils";
import { api } from "../api";
export default {
  components: {},
  props: {
    showGatePanel: {
      type: Boolean,
      default: false,
    },
    sceneCode: {
      type: String,
      default: "",
    },
  },
  watch: {
    showGatePanel: {
      handler(val) {
        this.showGatePanels = val;
        if (val) {
          this.getRecordList();
        } else {
          this.sceneCode = "";
          this.gateRecordList = [];
          this.page = {
            pageSize: 10,
            pageNum: 1,
          };
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      getTimeOut: null,
      showGatePanels: false,
      gateTypes: [
        { label: "人员通行记录", value: 1 },
        { label: "车辆通行记录", value: 2 },
      ],
      searchFormShow: false,
      checkTypeInfo: {
        type: 1,
        deviceId: "",
      },
      gateRecordList: [],
      isLastPage: true,
      page: {
        pageSize: 10,
        pageNum: 1,
      },
      dataLoading: false,
    };
  },
  beforeDestroy() {
    this.getTimeOut && clearTimeout(this.getTimeOut);
  },
  mounted() {
    this.scrollbar();
    this.gateRecordList = [];
  },
  methods: {
    imgChange(item) {
      if (item != '' && item != null && item != undefined) {
        let imgUrl = item.substring(item.indexOf('/d'))
        return imgUrl
      } else {
        return ''
      }
    },
    showViewer(e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    showCarViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    scrollbar() {
      this.gateList = this.$refs.gateList;
      this.boxScrollContainer = this.gateList.$el.querySelector(".el-scrollbar__wrap");
      this.scrollView = this.boxScrollContainer.querySelector(".el-scrollbar__view");
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
          this.scrollView.clientHeight &&
          !this.isLastPage &&
          !this.dataLoading
        ) {
          this.page.pageNum = this.page.pageNum + 1;
          this.getRecordList();
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    handleFilterType(item) {
      if (this.checkTypeInfo.type == 1) {
        return item.personnelType == 1 ? "内部员工" : "外来人员";
      } else {
        return item.carType == 1 ? "员工车辆" : "外来车辆";
      }
    },
    getImageUrl(fileCode) {
      return fileCode ? Bus.imgPath(fileCode) : "";
    },
    handleClosePanel() {
      this.$emit("handleCloseGate");
    },
    handleGateChange() {
      this.gateRecordList = [];
      this.page.pageNum = 1;
      this.getRecordList();
    },
    handSetTime() {
      if (this.getTimeOut) {
        clearTimeout(this.getTimeOut);
      }
      this.getTimeOut = setTimeout(() => {
        this.getRecordList();
      }, 1000 * 60 * 2);
    },
    //通行记录
    getRecordList() {
      this.dataLoading = true;
      let params = {
        sceneCode: this.sceneCode,
        passRecordType: this.checkTypeInfo.type,
        deviceId: this.checkTypeInfo.deviceId,
        ...this.page,
      };
      let apiUrl =
        this.checkTypeInfo.type == 1 ? api.getPersonRecordList : api.getVehicleRecordListNew;
      this.$fetch(apiUrl, params).then((res) => {
        setTimeout(() => {
          this.dataLoading = false;
        }, 500);
        if (res.success) {
          this.handSetTime();
          this.isLastPage = res.returnObj.isLastPage;
          this.gateRecordList = this.gateRecordList.concat([...res.returnObj.list]);
        } else {
          this.$message.error(res.msgContent || "查询失败");
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gate-page {
  position: absolute;
  right: 0;
  top: 49px;
  width: 350px;
  height: calc(100% - 49px);
  z-index: 9;
  transition: right 0.3s;

  .ioc-alarm__list__item li {
    height: 100%;
  }

  .gate-title {
    z-index: 2;
    padding: 12px 5px 12px 20px;
    background: #fff !important;
  }

  .gate-type {
    position: absolute;
    right: -140px;
    top: 3px;
    width: 36%;
    transition: right 0.3s;
  }

  .gate-item {
    display: flex;

    .img {
      width: 100%;
      height: 100%;
      border-radius: 6px;
    }

    .item-img {
      width: 70px;
      height: 70px;
    }

    .item-info {
      flex: 1;
      padding-left: 12px;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }

    .label {
      font-size: 12px;
      // color: #9aa6c1;
    }
  }
}

.searchFormShow {
  right: 15% !important;
}

.closeList {
  right: -350px !important;
}

.switch {
  left: 0 !important;
}

.noData {
  text-align: center;
  height: 80px;
}
</style>
